// Vendor Imports
import React from 'react';

// Project Imports
import ColorPicker from 'common/components/ColorPicker';

// Constants
import { COLORS } from 'common/authoring_workflow/constants';

export interface AgColorSelectorProps {
  uniqueId?: string;
  color: string;
  label: string;
  palette: string[];
  onChangeColor: (newColor: string) => void;
}

const AgColorSelector = (props: AgColorSelectorProps): JSX.Element => {
  const { color, onChangeColor, label, palette = COLORS, uniqueId } = props;
  const colorPickerAttributes = {
    handleColorChange: onChangeColor,
    palette: palette,
    value: color,
    id: uniqueId ? `${uniqueId}-ag-grid-color-picker` : 'ag-grid-color-picker'
  };

  return (
    <div className="authoring-field" data-testid="ag-grid-color-selector">
      <label className="block-label" htmlFor="primary-color">
        {label}
      </label>
      <ColorPicker {...colorPickerAttributes} />
    </div>
  );
};

export default AgColorSelector;
